var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRestaurantMarker = function SvgRestaurantMarker(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37,
    height: 62,
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "restaurantMarker_svg__a",
    d: "M9.706 0h6.47v22.647h-6.47z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.059 47.059)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.441,
    cy: 7.441,
    r: 6.941,
    fill: "#FFF",
    stroke: "#0A3847"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.441,
    cy: 7.441,
    r: 3.382,
    fill: "#0A3847"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1574F5",
    d: "m18.498 45.765-1.421-1.11C16.41 44.13.706 31.678.706 18.684.706 8.643 8.69.471 18.498.471c9.812 0 17.796 8.172 17.796 18.214 0 12.994-15.707 25.446-16.374 25.97z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.412 10.176)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.228 17.896s-.558-6.305-.558-6.839c0 0-.019-.192.19-.268.249-.092 1.298-.737 1.484-1.976 0 0 .072-.313 0-1.724 0 0 .092-5.788.126-6.715 0 0 .037-.314-.47-.37 0 0-.497-.068-.565.325 0 0-.284 3.821-.184 5.338 0 0 .138.987-.703 1.015 0 0-.822.112-.877-.71 0 0-.01-3.712.156-5.546 0 0 .026-.324-.455-.392 0 0-.496-.074-.58.372 0 0-.289 3.554-.177 5.426 0 0 .12.907-.777.884 0 0-.745.082-.805-.726 0 0 .113-5.082.156-5.476 0 0 .04-.419-.496-.448 0 0-.487-.047-.54.382 0 0-.221 6.076-.131 7.86 0 0 .002 1.834 1.69 2.56 0 0 .248.11.258.287l.506 6.751S2.436 19.424 4 19.412c1.435-.011 1.228-1.516 1.228-1.516"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "restaurantMarker_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#restaurantMarker_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.674.828s-.048-.671-.757-.804c0 0-.633-.18-1.24.444 0 0-4.085 3.917-3.969 9.335 0 0-.042 1.65.31 2.068 0 0 .217.285 1.305.337l1.381.12s.259.002.241.244l-.236 5.871s.02.984 1.412.969c1.824-.02 1.733-.886 1.733-.886s.834-12.494-.18-17.698",
    mask: "url(#restaurantMarker_svg__b)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRestaurantMarker);
export default ForwardRef;